import { useEffect, useState } from "react";
import BordFilterCard from "./CommonComponent/BordFilterCard";
import BordMegementHeader from "./CommonComponent/BordMegementHeader";
import BoardManagmentTable from "./CommonComponent/BoardManagmentTable";
import api from "@/services/api";
import { useDebounce } from "@/hooks/useDebounce";
import { toast } from "react-toastify";
import BordAddandEditDialogComponent from "./CommonComponent/BordAddandEditDialogComponent";
import BordDeleteDialogComponent from "./CommonComponent/BoradDeleteDialogComponent";
import ActiveInactiveComponent from "./CommonComponent/BoradActiveInactiveComponent";
import { Pagination } from "@mui/material";
import RowsPerPageDropdown from "../RowsPerPageDropdown";
import UploadCsv from "./CommonComponent/UploadCsv";
import ExportCsv from "./CommonComponent/ExportCsv";

const BoardName = () => {
    const prevSize = sessionStorage.getItem('prevSize')
    const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
    const [boardData, setBoardData] = useState<any[]>([])
    const [loadingForShimmer, setLoadingForShimmer] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [searchKeyword, setSearchKeyword] = useState('')
    const debouncedSearch = useDebounce(searchKeyword, 500)
    const [openDialog, setOpenDialog] = useState(false)
    const [addDialogLoading, setAddDialogLoading] = useState(false)
    const [deleteDialog, setDeleteDialog] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [selectedBoardForDelete, setSelectedBoardForDelete] = useState<any>(null)
    const [openToggle, setOpenToggle] = useState(false)
    const [toggleData, setToggleData] = useState<any>(null)
    const [openUpload, setOpenUpload] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        description: ""
    })
    const [editData, setEditData] = useState<any>(null)

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchBoardName()
    }, [debouncedSearch, pageSize, page]);

    const fetchBoardName = async () => {
        setLoading(true)
        setError('')
        try {
            setLoadingForShimmer(true)
            const params: Record<string, any> = {
                page: page,
                limit: pageSize,
            }

            if (searchKeyword?.trim()) {
                params.search = searchKeyword
            }

            const response = await api.get(`boards/board/list`, {
                params,
            })

            if (response?.data?.data) {
                setBoardData(response?.data?.data)
            } else {
                setError('No patients data found')
            }


            const pagination = response?.data?.pagination;
            if (pagination) {
                setTotalPages(Number(pagination.totalPages) || 1);
                // setTotalRecords(Number(pagination.total) || 0);
            }
        } catch (err: any) {
            console.error(err)
            setError('Failed to fetch patients')
        } finally {
            setLoadingForShimmer(false)
            setLoading(false)
        }
    }

    const handleOpenDialog = () => {
        setEditData(null)
        setFormData({ name: '', description: "" })
        setOpenDialog(true)
    }

    const handleEditBoard = (board: any) => {
        setEditData(board)
        setFormData({ name: board.name || '', description: board.description || '' })
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setEditData(null)
        setFormData({ name: '', description: "" })
    }




    const handleSubmit = async () => {
        if (!formData.name) {
            toast.error("Please enter name")
            return
        }
        if (!formData.description) {
            toast.error("Please enter description")
            return
        }

        const payload = { ...formData }

        try {
            if (editData) {
                setAddDialogLoading(true)
                const response = await api.patch(`boards/board/${editData._id}`, payload)
                if (response.status === 200) {
                    toast.success('Board Name updated successfully')
                    handleCloseDialog()
                    fetchBoardName()
                }
            } else {
                setAddDialogLoading(true)
                const response = await api.post('boards/board', payload)
                if (response.status === 201) {
                    toast.success('Board Name added successfully')
                    handleCloseDialog()
                    fetchBoardName()
                }
            }
        } catch (error: any) {
            console.error('Error adding board:', error)
            toast.error(error?.response?.data?.message || 'Failed to save board')
        } finally {
            setAddDialogLoading(false)
        }
    }

    const handleCloseDeleteDialog = () => {
        setDeleteDialog(false)
    }

    const handleConfirmDelete = async () => {
        if (!selectedBoardForDelete) {
            toast.error('No board selected for deletion')
            return
        }

        try {
            setDeleteLoading(true)
            const response = await api.delete(`boards/board/${selectedBoardForDelete._id}`)
            if (response.status === 200) {
                toast.success('Board deleted successfully')
                handleCloseDeleteDialog()
                fetchBoardName()
            }
        } catch (error: any) {
            console.error('Error deleting board:', error)
            toast.error(error?.response?.data?.message || 'Failed to delete board')
        } finally {
            setDeleteLoading(false)
        }
    }


    const handleCloseToggle = () => {
        setOpenToggle(false)
    }

    const handleConfirmToggle = async () => {
        if (!toggleData) {
            toast.error('No board selected for toggle')
            return
        }

        try {
            // setActive(!active)
            setLoading(true)

            const response = await api.patch(`boards/board/${toggleData._id}`, { isActive: !toggleData.isActive })
            if (response.status === 200) {
                toast.success('Board status updated successfully')
                handleCloseToggle()
                fetchBoardName()
            }
        } catch (error: any) {
            console.error('Error toggling board:', error)
            toast.error(error?.response?.data?.message || 'Failed to toggle board')
        } finally {
            setLoading(false)
        }
    }

    const handleReset = () => {
        setSearchKeyword('')

    }

    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(1);
    };

    return (
        <div>
            <BordMegementHeader
                handleOpenDialog={handleOpenDialog}
                title="Board Name"
                buttonText="Add Board Name"
            >
                <UploadCsv
                    apiUrl="boards/upload-board-csv"
                    title="Import Boards"
                />

                <ExportCsv
                    apiUrl="boards/export-board-names"
                    fileName="board_names.csv"
                />
            </BordMegementHeader>;
            <BordFilterCard
                searchLabel="Search Name"
                search={searchKeyword}
                setSearchKeyword={(val) => {
                    setSearchKeyword(val);
                    // setCurrentPage(1);
                }}
                handleReset={() => {
                    handleReset();
                    // setCurrentPage(1);
                }}
            />
            <BoardManagmentTable
                firstColumName="Name"
                secondColumName="Description"
                data={boardData}
                handleEditBoard={handleEditBoard}
                loadingForShimmer={loadingForShimmer}
                setDeleteDialog={setDeleteDialog}
                setSelectedBoardForDelete={setSelectedBoardForDelete}
                setToggleData={setToggleData}
                setOpenToggle={setOpenToggle}
            />
            <div className="flex justify-center mt-3">
                <div className="flex items-center gap-4">
                </div>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(e, value) => setPage(value)}
                // color="primary"
                />
            </div>

            <BordAddandEditDialogComponent
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
                addDialogLoading={addDialogLoading}
                handleSubmit={handleSubmit}
                editData={editData}
                formData={formData}
                setFormData={setFormData}
            />
            <BordDeleteDialogComponent
                deleteDialog={deleteDialog}
                handleCloseDeleteDialog={handleCloseDeleteDialog}
                deleteLoading={deleteLoading}
                handleConfirmDelete={handleConfirmDelete}
                loading={deleteLoading}
            />
            <ActiveInactiveComponent
                isActive={toggleData?.isActive}
                setOpenToggle={setOpenToggle}
                handleConfirmToggle={handleConfirmToggle}
                loading={loading}
                openToggle={openToggle}
            />
        </div>
    )
}

export default BoardName;